import Vue from "vue";

import RewardsGreeting from "./RewardsGreeting.vue";

export function load() {
    const selector = "rewards-greeting";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(RewardsGreeting, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
